import RatingFill from '@components/shared/RatingFill/RatingFill';
import VendorVariantContext from '@context/VendorVariant/vendor-variant-context';
import classNames from 'classnames';
import React, { useContext } from 'react';
import Price from '../Price/Price';
import styles from './StickyHeader.module.scss';
import { navigationHeights } from '../../../../../../styles/variables';

interface IStickyHeaderProps {
  className?: string;
  showStickyHeader: boolean;
  unbounceBannerHeight?: number;
  handleScrollToReview?: () => void;
  cartActions: any;
}

const StickyHeader = ({
  className = undefined,
  showStickyHeader,
  unbounceBannerHeight = 0,
  handleScrollToReview = () => {},
  cartActions
}: IStickyHeaderProps) => {
  const vendorVariant = useContext(VendorVariantContext);

  return (
    <div
      className={classNames(
        styles.StickyHeader,
        className,
        { [styles.Visible]: showStickyHeader },
        { [styles.Hidden]: !showStickyHeader },
      )}
      style={
        unbounceBannerHeight ? {
          top: `calc(${navigationHeights.shopNavigationHeight}px + ${unbounceBannerHeight}px)`
        } : {}
      }
      data-test="sticky-header"
    >
      <div className={styles.ProductInfo}>
        <span
          className={styles.ProductName}
          data-test="product-title"
        >
          {vendorVariant.title}
        </span>

        <div className={styles.PriceStarsWrapper}>
          <Price />
          {
            !!vendorVariant.reviewStats?.count &&
            !!vendorVariant.reviews?.items.length && (
              <button
                className={styles.ReviewWrapper}
                type="button"
                onClick={handleScrollToReview}
              >
                <RatingFill
                  compact
                  id="rating-summary"
                  rating={vendorVariant.reviewStats?.average || 5}
                  theme="havenly"
                />
                <span className={styles.ReviewCount}>
                  &#40;{vendorVariant.reviewStats.count}&#41;
                </span>
              </button>
            )
            }
        </div>
      </div>

      {cartActions}
    </div>
  );
};

export default StickyHeader;
